import { Component, OnInit } from '@angular/core';
import { TranslationService, CongresosService, UserService } from '../services/services.index';
import { Congreso } from '../models/congreso.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

declare var swal: any;

declare function init_plugins();

@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.component.html',
  styles: []
})
export class RecuperarPasswordComponent implements OnInit {

  loading: boolean = true;
  congreso: Congreso;

  forma: FormGroup;

  formInvalid: boolean = false;

  constructor(public _translationService: TranslationService,
              public _congresosService: CongresosService,
              public router: Router,
              public _userService: UserService) {

                this.forma = new FormGroup({
                  email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
                  codRecuperacion: new FormControl('', [Validators.required, Validators.minLength(3)]),
                  nuevaPassword: new FormControl('', [Validators.required, Validators.minLength(5)]),
                  repetirPassword: new FormControl('', [Validators.required, Validators.minLength(5)]),
                });

                this.forma.controls['repetirPassword'].setValidators([
                  Validators.required,
                  this.noIgual.bind(this.forma)
                ]);
              }

  ngOnInit() {
    init_plugins();
    this.cargarCongreso();
  }

  noIgual( control: FormControl ): {[s: string]: boolean} {

    let forma: any = this;
    if (control.value !== forma.controls['nuevaPassword'].value) {
      return{
        noiguales: true
      };
    }
    return null;
  }

  switchLanguage(language: string) {
    this._translationService.switchLanguage( language );
  }

  cargarCongreso() {
    this.loading = true;
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        this.loading = false;
      }
    });
  }

  getTituloByLang (objeto: any) {
    if (this._translationService.lang === 'es') {
      objeto.titulo_lang = objeto.titulo_es;
    } else if (this._translationService.lang === 'en') {
      objeto.titulo_lang = objeto.titulo_en;
    }
    return objeto.titulo_lang;
  }

  cambiarPassword() {
    let lang: string = this._translationService.lang;
    let titulo: string;
    let mensaje: string;
    if (lang === 'es') {
      titulo = 'Cambio de Password';
      mensaje = 'Su password ha sido cambiado correctamente.';
    } else {
      titulo = 'Change Password';
      mensaje = 'Your password has been changed correctly.';
    }
    if (this.forma.valid) {
      this.formInvalid = false;
      this._userService.validarRecuperarPassword(
        this.forma.controls['email'].value,
        this.forma.controls['codRecuperacion'].value,
        this.forma.controls['nuevaPassword'].value
      ).subscribe(resp => {
        swal(titulo, mensaje, 'success');
        this.router.navigate(['/login']);
      });
    } else {
      this.formInvalid = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/login/recuperar-password.component.ts